// import { useEffect } from "react";
import { FoundationsTooltipType } from '../Types/FoundationsTypes'
function FoundationsTooltip(props: FoundationsTooltipType) {
    return (
        <>
            <span
                id={props.id}
                style={props.style}
                title={props.text}
                className={'info-icon ' + (props.classes || '')}
                data-hasqtip="0"
                aria-describedby="qtip-0"
            >
                &#9432;
            </span>
        </>
    )
}

export { FoundationsTooltip }
